import axios from 'axios'
import * as types from './types'

export default {
  async [types.GET_SPECIALISTS_FOR_DEPARTMENT](_, departmentId) {
    const { data } = await axios.get(`/api/customers/specialty/${departmentId}/consultants`)
    return data
  },

  async [types.ASSIGN_SPECIALTY](_, payload) {
    const { data } = await axios.post('/api/customers/specialty/assign', payload)
    return data
  },
}
